import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { lineStringSchema } from "../geojson";
import { paginatedSchema } from "../pagination";

import { baseAssetSchema } from "./assetsBase";

export const pressurePipeListItemSchema = baseAssetSchema.extend({
  geometry: lineStringSchema,
  name: z.string(),
  length: z.number().nullable(),
  type: z.string(),
  material: z.string(),
  diameter: z.number().nullable(),
  shape: z.string(),
  year_of_construction: z.number().nullable(),
});

export type PressurePipeListItem = z.infer<typeof pressurePipeListItemSchema>;

export const pressurePipeListSchema = paginatedSchema(pressurePipeListItemSchema);
export type PressurePipeList = z.infer<typeof pressurePipeListSchema>;

export const pressurePipeSchema = pressurePipeListItemSchema;
export type PressurePipe = z.infer<typeof pressurePipeSchema>;

export function usePressurePipes(params = {}) {
  const url = combineUrlAndParams("/api/v4/pressurepipes/", params);
  return useParsedQuery<PressurePipeList>(
    ["lizard-api-v4", "pressurepipes", url],
    () => fetchWithError(url),
    (json: unknown) => pressurePipeListSchema.parse(json)
  );
}

export function usePressurePipe(id: number) {
  return useParsedQuery<PressurePipe>(
    ["lizard-api-v4", "pressurepipes", id],
    () => fetchWithError(`/api/v4/pressurepipes/${id}/`),
    (json: unknown) => pressurePipeSchema.parse(json)
  );
}

export function useMultiplePressurePipes(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "pressurepipes", id],
        fetchFunction: () => fetchWithError(`/api/v4/pressurepipes/${id}/`),
        parseFunction: (json: unknown) => pressurePipeSchema.parse(json),
      };
    })
  );
}
